import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const createAssetRegister = api(async function createAssetRegister(name, description) {
    return mutate(
        gql`
            mutation CreateAssetRegister($name: String!, $description: String) {
                createAssetRegister(name: $name, description: $description) {
                    id
                }
            }
        `,
        { name, description },
        { returns: "createAssetRegister.id" }
    )
})
